import { useMemo } from "react";
import useAppSelector from "@/core/helpers/useAppSelector";
import { charactersSelector, userSelector } from "@/domains/account/slice";
import AccountCharContainer from "@/domains/account/containers/char/AccountCharContainer.tsx";

const COUNT_LOCKED_SLOTS = 1;
const MAX_SLOTS = 3;

export default function AccountSlotsContainer() {
  const user = useAppSelector(userSelector);
  const characters = useAppSelector(charactersSelector);

  const freeSlots = useMemo(() => {
    if (user) {
      const totalSlots = Math.max(user?.maxCharacterSlots || 0, MAX_SLOTS);
      const slotsLeft = totalSlots - characters.length;

      if (slotsLeft <= 0) {
        return {
          free: 0,
          locked: 0,
        };
      }

      // Если пользователь купил все слоты, заблокированных слотов не должно быть
      if (user.maxCharacterSlots >= MAX_SLOTS) {
        return {
          free: slotsLeft,
          locked: 0,
        };
      }

      return {
        free: slotsLeft - COUNT_LOCKED_SLOTS,
        locked: COUNT_LOCKED_SLOTS,
      };
    }
    return {
      free: 0,
      locked: 0,
    };
  }, [user, characters]);

  return (
    <div className="grow relative flex flex-col justify-end overflow-hidden" id="account-main">
      <div className="flex justify-center items-end gap-3 xxl:gap-5 max-w-305 mx-auto w-full">
        {characters.map((character) => (
          <AccountCharContainer key={character.id} character={character} />
        ))}
        {[...Array(freeSlots.free)].map((_, i) => (
          <AccountCharContainer key={`${i + i}`} />
        ))}
        {[...Array(freeSlots.locked)].map((_, i) => (
          <AccountCharContainer key={`${i + i}`} isLocked />
        ))}
      </div>
    </div>
  );
}
